import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const USER_AUTH_DATA = 'SessionDataUserAuth';
const USER_INIT= 'userInit';
@Injectable()
export class IdentityStorage {

    constructor() { }

    public saveAuthData(userData: any) {
        this.clearAuthData();
        window.sessionStorage.setItem(USER_AUTH_DATA, JSON.stringify(userData));
    }

    public saveTokenInit(userData: any) {
        this.clearAuthData();
        window.sessionStorage.setItem(USER_INIT, JSON.stringify(userData.token));
    }

    public clearAuthData() {
        window.sessionStorage.removeItem(USER_AUTH_DATA);
        window.sessionStorage.clear();
    }

    public authenticationPresent(): boolean {
        return window.sessionStorage.getItem(USER_AUTH_DATA) !== null;
    }

    public authenticationInitPresent(): boolean {
        return window.sessionStorage.getItem(USER_INIT) !== null;
    }

    public getUserAuthData(): any {
        const userAuthData: any = JSON.parse(sessionStorage.getItem(USER_AUTH_DATA));
        return userAuthData;
    }

    public getUserInit(): any {
        const userInit: any = JSON.parse(sessionStorage.getItem(USER_INIT));
        return userInit;
    }

    public getIdentityPromise(): Observable<any> {
        return this.getUserAuthData();
    }
}
